import { apiSlice } from "../../app/api/apiSlice";
import { urlConfig } from "../../config";

export interface StreakStatus {
  isFeatureEnabled: boolean;
  currentStreak: number;
  streakStartedAt: string | null;
  lastTradeAt: string | null;
  hoursRemaining: number | null;
  isSafeToday: boolean;
  redeemAvailable: boolean;
  rewardAmount: number;
  totalStreaksCompleted: number;
  totalBonusesEarned: number;
  streakRequiredDays: number;
  // Minimum naira value a trade needs to count; absent on older backends.
  minTradeValue?: number;
}

export interface RedeemStreakResponse {
  success: boolean;
  amountCredited: number;
  newWalletBalance: number;
  message: string;
}

export interface StreakHistoryItem {
  _id: string;
  amount: number;
  streakCount: number;
  reason: string | null;
  createdAt: string;
}

export interface StreakHistoryResponse {
  data: StreakHistoryItem[];
  total: number;
  page: number;
  last_page: number;
}

export interface StreakHistoryArgs {
  page?: number;
  limit?: number;
}

export const streakSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    // Get current streak status
    getStreakStatus: build.query<StreakStatus, void>({
      query: () =>
        `${urlConfig.transactionsBaseUrl}/transactions/streak/status`,
      providesTags: ["Streak"],
    }),

    // Paginated reward history (newest first)
    getStreakHistory: build.query<StreakHistoryResponse, StreakHistoryArgs | void>({
      query: (args) => {
        const page = args?.page ?? 1;
        const limit = args?.limit ?? 10;
        return `${urlConfig.transactionsBaseUrl}/transactions/streak/history?page=${page}&limit=${limit}`;
      },
      providesTags: ["Streak"],
    }),

    // Redeem streak bonus
    redeemStreakBonus: build.mutation<RedeemStreakResponse, void>({
      query: () => ({
        url: `${urlConfig.transactionsBaseUrl}/transactions/streak/redeem`,
        method: "POST",
      }),
      invalidatesTags: ["Streak", "Wallet"],
    }),
  }),
});

export const {
  useGetStreakStatusQuery,
  useGetStreakHistoryQuery,
  useRedeemStreakBonusMutation,
} = streakSlice;
